var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center justify-space-between",attrs:{"id":"auth_header"}},[_c('div',[_c('v-img',{attrs:{"src":require("@/assets/logos/muwahib_logo.svg"),"alt":"Muwahib","width":"161px","height":"66px"}})],1),_c('ChangeLanguage',{attrs:{"extra_padding_class":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }